/* eslint-disable consistent-return */
import { IStore } from 'store/types';
import { IPaymentSet } from 'types';

export const selectPaymentSetsForSite =
  () =>
  (state: IStore): IPaymentSet[] =>
    state.collections.payments?.data as IPaymentSet[];

export const selectTotalCountPaymentSetsForSite =
  () =>
  (state: IStore): number =>
    state.collections.payments?.total;
